import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 set_masked_credentials: { message: "idle" },
};

export const set_masked_credentials_Slice = createSlice({
 name: "set_masked_credentials",
 initialState,
 reducers: {
  success_set_masked_credentials: (state, action) => {
   state.set_masked_credentials = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_set_masked_credentials: (state, action) => {
   state.set_masked_credentials = { status: app_consts.FAIL, message: action.payload };
  },
  reset_set_masked_credentials: (state) => {
   state.set_masked_credentials = { status: app_consts.IDLE };
  },
  loading_set_masked_credentials: (state) => {
   state.set_masked_credentials = { status: app_consts.LOADING };
  },
 }
});

export const { success_set_masked_credentials, fail_set_masked_credentials, reset_set_masked_credentials, loading_set_masked_credentials } = set_masked_credentials_Slice.actions;

export default set_masked_credentials_Slice.reducer;